import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { useEncryptedEndpointsRadioSwitch } from './linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';
import { parameterizeDynamicsControlMetadata } from '../consts/metadata-consts';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { GlobalVariables } from 'app/services/globals';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { getConnectorV1Name, getConnectorV2Name, serviceNowAuthTypes } from 'shell-models-lib';

function getControlMetadata(control: ControlMetadata): ControlMetadata {
    return GlobalVariables.serviceNowParamedLs ? parameterizeDynamicsControlMetadata(control) : control;
}

export const endpoint: ControlMetadata = {
    type: 'textbox',
    bind: 'endpoint',
    label: stringResources.ModelName_Endpoint,
    required: true,
    placeholder: stringResources.ServiceNow_Endpoint_Placeholder,
    validators: [
        { type: 'required', errorMessage: '' }
    ],
    isLabelVertical: true
};

export const username: ControlMetadata = {
    type: 'textbox',
    bind: 'username',
    required: true,
    label: stringResources.ModelName_UserName,
    isLabelVertical: true,
    validators: [
        { type: 'required', errorMessage: '' }
    ]
};

export const password: ControlMetadata = {
    type: 'dynamic-akv-switcher',
    bind: 'password',
    label: stringResources.ModelName_Password,
    child: {
        type: 'password',
        required: true,
        label: stringResources.ModelName_Password,
        isLabelVertical: true
    },
    validators: [
        { type: 'required', errorMessage: '' }
    ],
    description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.ServiceNow_DisplayText),
        stringResources.ModelName_Password)
};

export const clientId: ControlMetadata = {
    type: 'textbox',
    bind: 'clientId',
    required: true,
    label: stringResources.ModelName_ClientId,
    isLabelVertical: true
};

export const clientSecret: ControlMetadata = {
    type: 'dynamic-akv-switcher',
    bind: 'clientSecret',
    label: stringResources.ModelName_ClientSecret,
    child: {
        type: 'password',
        required: true,
        label: stringResources.ModelName_ClientSecret,
        isLabelVertical: true
    },
    validators: [
        { type: 'required', errorMessage: '' }
    ],
    description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.ServiceNow_DisplayText),
        stringResources.ModelName_ClientSecret)
};

export const serviceNowMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.serviceNow.linkedServiceType,
    disabled: __IS_FABRIC_DPE__,
    isDeprecated: !GlobalVariables.showLegacy,
    notShowInTypeSelection: !GlobalVariables.showLegacy,
    displayName: getConnectorV1Name(stringResources.ServiceNow_DisplayText),
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.LinkedServiceLowerCase,
        getConnectorV2Name(stringResources.ServiceNow_DisplayText)
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-servicenow',
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-servicenow'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [adfModelTypeMap.serviceNow.copySourceType],
    supportFirstClassParameterExperience: GlobalVariables.serviceNowParamedLs,
    controls: [
        getControlMetadata(endpoint),
        {
            type: 'select-switch',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            options: [
                {
                    label: stringResources.Basic_DisplayText,
                    value: serviceNowAuthTypes.Basic
                },
                {
                    label: stringResources.AuthenticationType_OAuth2,
                    value: serviceNowAuthTypes.OAuth2
                }
            ],
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
            defaultValue: serviceNowAuthTypes.Basic,
            cases: [
                {
                    caseValue: serviceNowAuthTypes.Basic,
                    children: [
                        getControlMetadata(username),
                        getControlMetadata(password)
                    ]
                },
                {
                    caseValue: serviceNowAuthTypes.OAuth2,
                    children: [
                        getControlMetadata(username),
                        getControlMetadata(password),
                        getControlMetadata(clientId),
                        getControlMetadata(clientSecret),
                    ]
                }
            ]
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
